import { render } from "./BaseSpinner.vue?vue&type=template&id=042cd4ba&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=042cd4ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042cd4ba"]])

export default __exports__